import { render, staticRenderFns } from "./UpgradePrompt.vue?vue&type=template&id=6bad2e50&scoped=true"
import script from "./UpgradePrompt.vue?vue&type=script&lang=js"
export * from "./UpgradePrompt.vue?vue&type=script&lang=js"
import style0 from "./UpgradePrompt.vue?vue&type=style&index=0&id=6bad2e50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bad2e50",
  null
  
)

export default component.exports